<div class="thread-under-moderation unselectable">
    <div class="thread-under-moderation-text">
        {{thread.moderationStatus | translate }}
    </div>

    <div class="thread-under-moderation-background">
        <div class="avatar" [style.color]="thread.author.color">
            <i class="far {{thread.author.icon}}"></i>
        </div>

        <div class="media-body message">
            <p class="author">{{thread.author.name }} • <span
                    [hidden]="!thread.isMoodAuthor">
                    <span class="badge bg-primary">{{ 'comment-card.author' |
                        translate}}</span>
                </span>
                <span class="date">
                    @if (thread.isEdited) {
                        <i>edited </i>
                    }
                    {{thread.datetime }}
                </span>
            </p>
            <p class="body">
                <span [innerHTML]="$safeNavigationMigration(thread.message?.rawTextFormat) | translate"></span>
            </p>
        </div>

        <div class="thread-actions">
        </div>
    </div>
</div>